module.exports = __webpack_public_path__ + "img/bg-yellow.dc61948e.svg";